import { ITranslations } from './transactionTypes';

export interface IActionDto {
  id: string;
  version: string;
}
export interface IVatRate extends ITranslatableEntity {
  vatPercentage: number;
}
export interface ICostCenter {
  status: string;
  name?: string;
  description?: string;
}
export interface ITranslatableEntity {
  translations: ITranslations[];
  status: string;
  description: string;
  name: string;
}
export enum ParameterEntityType {
  INVOICE = 'invoice',
  INVOICE_PRINTING = 'invoice-printing',
  FEATURES_IN_USE = 'features-in-use',
  SERVICE_RESTRICTION = 'service-restriction',
  TRANSACTION_POSTING_PERIOD = 'transaction-posting-period',
  TRANSACTION = 'transaction',
  PRELIMINARY_INVOICE = 'preliminary-invoice',
  DEFAULT = 'default',
  CUSTOMER_IDENTIFICATION = 'customer-identification',
  PRICING = 'pricing',
  INVOICING_PERIOD = 'invoicing-period',
  MATTER_SECURITY = 'matter-security',
  ENTRIES_SECURITY = 'entries-security',
  CRITICAL_TASK_OFFICE_365_SYNCHRONIZATION = 'critical-task-office-365-synchronization',
}
export enum InvoicingException {
  MatterNotFoundException = 'MatterNotFoundException',
  MatterIsNotInvoiceableException = 'MatterIsNotInvoiceableException',
  FiscalPeriodDoesNotExistsException = 'FiscalPeriodDoesNotExistsException',
  MatterHasOpenPreliminaryInvoiceAlreadyException = 'MatterHasOpenPreliminaryInvoiceAlreadyException',
  MatterHasNoInvoiceableTransactionsOrExpensesException = 'MatterHasNoInvoiceableTransactionsOrExpensesException',
  TransactionPostingPeriodDoesNotExistException = 'TransactionPostingPeriodDoesNotExistException',
  MatterHasIncompleteTransactionsException = 'MatterHasIncompleteTransactionsException',
  PrincipalIsNotIdentifiedException = 'PrincipalIsNotIdentifiedException',
  PayerHasDiscountTableException = 'PayerHasDiscountTableException',
  UserHasNoPermissionToPreliminaryInvoiceException = 'UserHasNoPermissionToPreliminaryInvoiceException',
  InvoicingPeriodIsNotInUseException = 'InvoicingPeriodIsNotInUseException',
  MatterIsOrHasSubMatterException = 'MatterIsOrHasSubMatterException',

  //These are not real API exceptions, just makes sense to reuse this enum class for other error messages
  MatterHasSubMattersException = 'MatterHasSubMattersException',
  MatterIsSubMatterException = 'MatterIsSubMattersException',
}
export enum TransactionException {
  TransactionCantBeRemovedException = 'TransactionCantBeRemovedException',
}
export enum TransactionPostingPeriodException {
  OpeningOutOfSequenceIsNotAllowedException = 'OpeningOutOfSequenceIsNotAllowedException',
  OpeningTooFarIntoTheFutureException = 'OpeningTooFarIntoTheFutureException',
}

export enum TransactionCreationException {
  TransactionServiceRestrictionErrorException = 'TransactionServiceRestrictionErrorException',
  TransactionCustomerIdentificationErrorException = 'TransactionCustomerIdentificationErrorException',
  TransactionPostingPeriodDoesNotExistException = 'TransactionPostingPeriodDoesNotExistException',
  CannotLinkToClosedMatterException = 'CannotLinkToClosedMatterException',
}
export enum TaskCreationException {
  CannotLinkToClosedMatterException = 'CannotLinkToClosedMatterException',
}
export enum MatterRequestException {
  InsiderMatterRequestPermissionDeniedException = 'InsiderMatterRequestPermissionDeniedException',
  MatterRequestProtectedFieldsPermissionDeniedException = 'MatterRequestProtectedFieldsPermissionDeniedException',
}

export interface IAPIError {
  statusCode: number;
  type: string;
  name: string;
  message: string;
  stack: string;
  timestamp: string;
  path: string;
}
export enum TagColor {
  GREEN = 'green',
  LIGHTBLUE = 'light-blue',
  LIGHTGREEN = 'light-green',
  YELLOW = 'yellow',
  BLUE = 'blue',
  BEIGE = 'beige',
  RED = 'red',
  PURPLE = 'purple',
  DARKGREY = 'dark-grey',
}

export enum BorderColor {
  GREEN = 'border-green',
  LIGHTBLUE = 'border-light-blue',
  LIGHTGREEN = 'border-light-green',
  YELLOW = 'border-yellow',
  BLUE = 'border-blue',
  BEIGE = 'border-beige',
  RED = 'border-red',
  PURPLE = 'border-purple',
  DARKGREY = 'border-dark-grey',
}
export enum Entities {
  MATTER = 'matter',
  TRANSACTION = 'transaction',
  CUSTOMER = 'customer',
  PRELIMINARYINVOICE = 'preliminaryinvoice',
  MATTERREQUEST = 'matterrequest',
  ACTIVITY = 'activity',
  CONFLICTCHECKS = 'conflictchecks',
}
export type SortDirection = 'ASC' | 'DESC';
export type SortFieldType = 'text' | 'number' | 'date';

export interface ISortOption {
  field: string;
  label: string;
  type: SortFieldType;
  defaultDirection: SortDirection;
}

export interface IActiveSortState {
  field: string;
  direction: SortDirection;
}

export enum EntityStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
